export default __webpack_public_path__ + "static/media/sydney.4dc0cad8.png";